module.exports = __webpack_public_path__ + "static/media/medical-result.f2846c5d.svg";